import { Attachment } from "./chat"
import { Collection } from "./collection"
import { Inspiration } from "./inspiration"
import { PublicUser } from "./user"

export const MEDIA_INSPIRATION = "Inspiration"
export const MEDIA_SAVED_COLLECTION = "SavedCollection"
export const MEDIA_FILE = "File"
export const MEDIA_LINK = "Link"

export const VALID_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/tiff",
  "image/heic",
  "image/heif",
  "image/svg+xml",
]

export const VALID_VIDEO_TYPES = ["video/mp4", "video/quicktime"]

export const VALID_DOCUMENT_TYPES = ["application/pdf"]

export const VALID_AUDIO_TYPES = [
  "audio/mpeg",
  "audio/wav",
  "audio/x-wav", // For Safari
  "audio/m4a",
  "audio/x-m4a", // For Safari
]

export const VALID_IMAGE_VIDEO_TYPES = [
  ...VALID_IMAGE_TYPES,
  ...VALID_VIDEO_TYPES,
]

export const VALID_ATTACHMENT_TYPES = [
  ...VALID_IMAGE_TYPES,
  ...VALID_DOCUMENT_TYPES,
]

export const VALID_IMAGE_VIDEO_DOC_TYPES = [
  ...VALID_IMAGE_TYPES,
  ...VALID_VIDEO_TYPES,
  ...VALID_DOCUMENT_TYPES,
]

// File extensions
export const IMAGE_FILE_EXTENSIONS = [
  ".jpeg",
  ".jpg",
  ".png",
  ".gif",
  ".webp",
  ".tiff",
  ".heif",
  ".heic",
  ".svg",
]

export const VIDEO_FILE_EXTENSIONS = [".mp4", ".mov"]

export const DOCUMENT_FILE_EXTENSIONS = [".pdf"]

export const AUDIO_FILE_EXTENSIONS = [".mp3", ".wav", ".m4a"]

export const IMAGE_VIDEO_FILE_EXTENSIONS = [
  ...IMAGE_FILE_EXTENSIONS,
  ...VIDEO_FILE_EXTENSIONS,
]

export const ATTACHMENT_FILE_EXTENSIONS = [
  ...IMAGE_FILE_EXTENSIONS,
  ...DOCUMENT_FILE_EXTENSIONS,
]

export const IMAGE_VIDEO_DOC_FILE_EXTENSIONS = [
  ...IMAGE_FILE_EXTENSIONS,
  ...VIDEO_FILE_EXTENSIONS,
  ...DOCUMENT_FILE_EXTENSIONS,
]

// Accepted files extensions as string
export const ACCEPTED_IMAGE_EXTENSIONS = IMAGE_FILE_EXTENSIONS.join(",")
export const ACCEPTED_VIDEO_EXTENSIONS = VIDEO_FILE_EXTENSIONS.join(",")
export const ACCEPTED_IMAGE_VIDEO_EXTENSIONS =
  IMAGE_VIDEO_FILE_EXTENSIONS.join(",")
export const ACCEPTED_AUDIO_FILE_EXTENSIONS = AUDIO_FILE_EXTENSIONS.join(",")
export const ACCEPTED_ATTACHMENT_EXTENSIONS =
  ATTACHMENT_FILE_EXTENSIONS.join(",")
export const ACCEPTED_IMAGE_VIDEO_DOC_EXTENSIONS =
  IMAGE_VIDEO_DOC_FILE_EXTENSIONS.join(",")

// Sizes
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024 // 10MB size
export const MAX_VIDEO_SIZE = 20 * 1024 * 1024 // 20MB size
export const MAX_LOGO_IMAGE_SIZE = 500 * 1024 // 500KB for organization logos
export const MAX_AVATAR_IMAGE_SIZE = 2 * 1024 * 1024 // 2MB size (to be consistent with backend)

export const MediaFetchPerPageSize = 8

export type MediaRef = `md-${string}`
export const MediaRefRE = /^md-[a-zA-Z0-9]{8}$/

export interface AbstractMedia {
  ref: MediaRef
  user: PublicUser
}

export interface MediaGuide extends AbstractMedia {
  kind: "Inspiration"
  inspiration: Inspiration
}

export interface MediaCollection extends AbstractMedia {
  kind: "SavedCollection"
  collection: Collection
}

export interface MediaFile extends AbstractMedia {
  kind: "File"
  attachment: Attachment
}

export interface MediaLink extends AbstractMedia {
  kind: "Link"
  attachment: Attachment
}

export type Media = MediaGuide | MediaCollection | MediaFile | MediaLink

export function isMediaRef(value: string): value is MediaRef {
  return MediaRefRE.test(value)
}
